
<div>
    <div class="top-site primary" v-if="!site" style="height: 142px">
    </div>
    <div class="top-site primary" v-if="site">
        <c-site-title-row
            :context = "site"
            @customer = "onCustomer"
        />

        <c-site-contact-row
            :contacts    = "contacts"
            :contracts   = "site.liftmanagement"
            :liftmanager = "site.customer.responsibles"
            class        = "mt-3"
        />
    </div>
</div>

